export default function useCustomMethods() {
  const getColor = (success, error, val) => {
    success = success.map((element) => element.toLowerCase());
    error = error.map((element) => element.toLowerCase());
    if (val) val = val.toLowerCase();
    if (success.includes(val)) return "text-success";
    else if (error.includes(val)) return "text-danger";
    else return "text-warning";
  };

  const firstLetterUpperCase = (str) => {
    if (str) return str.charAt(0).toUpperCase() + str.slice(1);
    return;
  };

  const replaceUrl = (url) => {
    let result = url.replace(/([^:]\/)\/+/g, "$1");
    return result;
  };

  const isVideoUrl = (url) => {
    const dataFormat = ["mp4", "mov", "webm", "avi", "mkv"];
    if (url) {
      const dataUrl = url.split(".").pop().toLowerCase();
      return dataFormat.includes(dataUrl);
    }
    return false;
  };

  const formatDateTime = (dataString) => {
    const date = new Date(dataString);
    const formatted = date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return formatted;
  };

  return {
    getColor,
    firstLetterUpperCase,
    replaceUrl,
    isVideoUrl,
    formatDateTime,
  };
}
